import { inject, observer } from 'mobx-react'
import React from 'react'
import { RouteComponentProps } from 'react-router'
import { withStateCard, TutorialButtonAndBackButton, ToastType, Toast } from '../../Components'
import { PreProjetoStore, PREPROJETO_STORE, ParametrosPreProjetoValidator } from '../../Store'
import Tutorial_Funcionario from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Funcionario.pdf"
import { GlobalErrorToast } from '../Shared/GlobalErrorToast'
import ParamsPreProjetoCard from './Components/ParamsPreProjetoCard'
import { format } from 'date-fns'
import styled from 'styled-components'

interface IProps extends RouteComponentProps<{ id: string }> {
    [PREPROJETO_STORE]: PreProjetoStore;
}

interface IState {
    serie: string,
    dataDeInicio: string, horaDeInicio: string,
    dataDeFim: string, horaDeFim: string,
    dataDeInicioInscricoes: string, horaDeInicioInscricoes: string,
    dataDeFimInscricoes: string, horaDeFimInscricoes: string,
    dataDeInicioPF: string, horaDeInicioPF: string,
    dataDeFimPF: string, horaDeFimPF: string,
    dataDeInicioSF: string, horaDeInicioSF: string,
    dataDeFimSF: string, horaDeFimSF: string,
    dataDeInicioTF: string, horaDeInicioTF: string,
    dataDeFimTF: string, horaDeFimTF: string,
    observacao: string,
    editar: boolean,
    sucesso: boolean
}

const Container: React.FC = (props: React.HTMLAttributes<HTMLDivElement>) => <>{props.children}</>;
const ParamsPreProjetoCardWithState = withStateCard(Container);

const StyledText = styled.span`
  padding: 5px;
`

@inject(PREPROJETO_STORE)
@observer
export default class ParametrosPreProjetoPage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)

        this.state = {
            serie: '',
            dataDeInicio: '', horaDeInicio: '',
            dataDeFim: '', horaDeFim: '',
            dataDeInicioInscricoes: '', horaDeInicioInscricoes: '',
            dataDeFimInscricoes: '', horaDeFimInscricoes: '',
            dataDeInicioPF: '', horaDeInicioPF: '',
            dataDeFimPF: '', horaDeFimPF: '',
            dataDeInicioSF: '', horaDeInicioSF: '',
            dataDeFimSF: '', horaDeFimSF: '',
            dataDeInicioTF: '', horaDeInicioTF: '',
            dataDeFimTF: '', horaDeFimTF: '',
            observacao: '',
            editar: false,
            sucesso: false
        }
    }

    onResumeClick = () => {
        window.open(Tutorial_Funcionario);
    }

    componentDidMount() {
        this.retornarParametro()
    }

    retornarParametro = async () => {
        const store = this.props[PREPROJETO_STORE]
        const { match } = this.props

        await store.getParamsPreProjetoPeloId(parseInt(match.params.id))
        const { parametros } = store

        if (parametros) {
            this.setState({
                serie: parametros.serie,
                dataDeInicio: format(parametros.dataDeInicio, 'YYYY-MM-DD'),
                horaDeInicio: format(parametros.dataDeInicio, 'HH:mm'),
                dataDeFim: format(parametros.dataDeFim, 'YYYY-MM-DD'),
                horaDeFim: format(parametros.dataDeFim, 'HH:mm'),
                dataDeInicioInscricoes: format(parametros.dataDeInicioInscricoes, 'YYYY-MM-DD'),
                horaDeInicioInscricoes: format(parametros.dataDeInicioInscricoes, 'HH:mm'),
                dataDeFimInscricoes: format(parametros.dataDeFimInscricoes, 'YYYY-MM-DD'),
                horaDeFimInscricoes: format(parametros.dataDeFimInscricoes, 'HH:mm'),
                dataDeInicioPF: format(parametros.dataDeInicioPF, 'YYYY-MM-DD'),
                horaDeInicioPF: format(parametros.dataDeInicioPF, 'HH:mm'),
                dataDeFimPF: format(parametros.dataDeFimPF, 'YYYY-MM-DD'),
                horaDeFimPF: format(parametros.dataDeFimPF, 'HH:mm'),
                dataDeInicioSF: format(parametros.dataDeInicioSF, 'YYYY-MM-DD'),
                horaDeInicioSF: format(parametros.dataDeInicioSF, 'HH:mm'),
                dataDeFimSF: format(parametros.dataDeFimSF, 'YYYY-MM-DD'),
                horaDeFimSF: format(parametros.dataDeFimSF, 'HH:mm'),
                dataDeInicioTF: format(parametros.dataDeInicioTF, 'YYYY-MM-DD'),
                horaDeInicioTF: format(parametros.dataDeInicioTF, 'HH:mm'),
                dataDeFimTF: format(parametros.dataDeFimTF, 'YYYY-MM-DD'),
                horaDeFimTF: format(parametros.dataDeFimTF, 'HH:mm'),
                observacao: parametros.observacao,
                editar: true
            })
        }
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        var partialState = {};
        partialState[name] = value;
        this.setState(partialState)
    }

    criarNovoParam = async () => {
        const store = this.props[PREPROJETO_STORE]
        const { setParametrosError, parametrosPreProjetoValidationError } = store

        const errors = ParametrosPreProjetoValidator.getErrors({
            serie: this.state.serie,
            dataDeInicio: this.state.dataDeInicio,
            horaDeInicio: this.state.horaDeInicio,
            dataDeFim: this.state.dataDeFim,
            horaDeFim: this.state.horaDeFim,
            dataDeInicioInscricoes: this.state.dataDeInicioInscricoes,
            horaDeInicioInscricoes: this.state.horaDeInicioInscricoes,
            dataDeFimInscricoes: this.state.dataDeFimInscricoes,
            horaDeFimInscricoes: this.state.horaDeFimInscricoes,
            dataDeInicioPF: this.state.dataDeInicioPF,
            horaDeInicioPF: this.state.horaDeInicioPF,
            dataDeFimPF: this.state.dataDeFimPF,
            horaDeFimPF: this.state.horaDeFimPF,
            dataDeInicioSF: this.state.dataDeInicioSF,
            horaDeInicioSF: this.state.horaDeInicioSF,
            dataDeFimSF: this.state.dataDeFimSF,
            horaDeFimSF: this.state.horaDeFimSF,
            dataDeInicioTF: this.state.dataDeInicioTF,
            horaDeInicioTF: this.state.horaDeInicioTF,
            dataDeFimTF: this.state.dataDeFimTF,
            horaDeFimTF: this.state.horaDeFimTF
        })

        if (errors) {
            setParametrosError(errors)
            return
        }

        setParametrosError({})
        await store.criarNovoParametro(
            this.state.serie,
            this.state.dataDeInicio, this.state.horaDeInicio,
            this.state.dataDeFim, this.state.horaDeFim,
            this.state.dataDeInicioInscricoes, this.state.horaDeInicioInscricoes,
            this.state.dataDeFimInscricoes, this.state.horaDeFimInscricoes,
            this.state.dataDeInicioPF, this.state.horaDeInicioPF,
            this.state.dataDeFimPF, this.state.horaDeFimPF,
            this.state.dataDeInicioSF, this.state.horaDeInicioSF,
            this.state.dataDeFimSF, this.state.horaDeFimSF,
            this.state.dataDeInicioTF, this.state.horaDeInicioTF,
            this.state.dataDeFimTF, this.state.horaDeFimTF,
            this.state.observacao
        )
        if (parametrosPreProjetoValidationError && parametrosPreProjetoValidationError.global) {
            this.setState({ sucesso: true })
        }
    }

    editarParam = async () => {
        const store = this.props[PREPROJETO_STORE]
        const { setParametrosError, parametros, parametrosPreProjetoValidationError } = store

        const errors = ParametrosPreProjetoValidator.getErrors({
            serie: this.state.serie,
            dataDeInicio: this.state.dataDeInicio,
            horaDeInicio: this.state.horaDeInicio,
            dataDeFim: this.state.dataDeFim,
            horaDeFim: this.state.horaDeFim,
            dataDeInicioInscricoes: this.state.dataDeInicioInscricoes,
            horaDeInicioInscricoes: this.state.horaDeInicioInscricoes,
            dataDeFimInscricoes: this.state.dataDeFimInscricoes,
            horaDeFimInscricoes: this.state.horaDeFimInscricoes,
            dataDeInicioPF: this.state.dataDeInicioPF,
            horaDeInicioPF: this.state.horaDeInicioPF,
            dataDeFimPF: this.state.dataDeFimPF,
            horaDeFimPF: this.state.horaDeFimPF,
            dataDeInicioSF: this.state.dataDeInicioSF,
            horaDeInicioSF: this.state.horaDeInicioSF,
            dataDeFimSF: this.state.dataDeFimSF,
            horaDeFimSF: this.state.horaDeFimSF,
            dataDeInicioTF: this.state.dataDeInicioTF,
            horaDeInicioTF: this.state.horaDeInicioTF,
            dataDeFimTF: this.state.dataDeFimTF,
            horaDeFimTF: this.state.horaDeFimTF
        })

        if (errors) {
            setParametrosError(errors)
            return
        }

        setParametrosError({})
        await store.editarParametro(
            parametros.id,
            this.state.serie,
            this.state.dataDeInicio, this.state.horaDeInicio,
            this.state.dataDeFim, this.state.horaDeFim,
            this.state.dataDeInicioInscricoes, this.state.horaDeInicioInscricoes,
            this.state.dataDeFimInscricoes, this.state.horaDeFimInscricoes,
            this.state.dataDeInicioPF, this.state.horaDeInicioPF,
            this.state.dataDeFimPF, this.state.horaDeFimPF,
            this.state.dataDeInicioSF, this.state.horaDeInicioSF,
            this.state.dataDeFimSF, this.state.horaDeFimSF,
            this.state.dataDeInicioTF, this.state.horaDeInicioTF,
            this.state.dataDeFimTF, this.state.horaDeFimTF,
            this.state.observacao
        )
        if (parametrosPreProjetoValidationError && parametrosPreProjetoValidationError.global) {
            this.setState({ sucesso: true })
        }
    }

    render() {
        const preProjetoStore = this.props[PREPROJETO_STORE]
        const { preProjetoState, parametrosPreProjetoValidationError } = preProjetoStore;
        const { history } = this.props;

        return (
            <>
                <TutorialButtonAndBackButton
                    openTutorial={this.onResumeClick}
                    voltar={() => history.push('/funcionario')}
                />
                <ParamsPreProjetoCardWithState
                    state={preProjetoState}
                    loading='Carregando...'
                >
                    <GlobalErrorToast
                        messages={parametrosPreProjetoValidationError && parametrosPreProjetoValidationError.global}
                    />
                    {this.state.sucesso &&
                        <Toast type={ToastType.success}>
                            <StyledText>
                                {this.state.editar ? 'Alterações salvas.' : 'Novo parâmetro criado.'}
                            </StyledText>
                        </Toast>
                    }
                    <ParamsPreProjetoCard
                        serie={this.state.serie}
                        dataDeInicio={this.state.dataDeInicio}
                        horaDeInicio={this.state.horaDeInicio}
                        dataDeFim={this.state.dataDeFim}
                        horaDeFim={this.state.horaDeFim}
                        dataDeInicioInscricoes={this.state.dataDeInicioInscricoes}
                        horaDeInicioInscricoes={this.state.horaDeInicioInscricoes}
                        dataDeFimInscricoes={this.state.dataDeFimInscricoes}
                        horaDeFimInscricoes={this.state.horaDeFimInscricoes}
                        dataDeInicioPF={this.state.dataDeInicioPF}
                        horaDeInicioPF={this.state.horaDeInicioPF}
                        dataDeFimPF={this.state.dataDeFimPF}
                        horaDeFimPF={this.state.horaDeFimPF}
                        dataDeInicioSF={this.state.dataDeInicioSF}
                        horaDeInicioSF={this.state.horaDeInicioSF}
                        dataDeFimSF={this.state.dataDeFimSF}
                        horaDeFimSF={this.state.horaDeFimSF}
                        dataDeInicioTF={this.state.dataDeInicioTF}
                        horaDeInicioTF={this.state.horaDeInicioTF}
                        dataDeFimTF={this.state.dataDeFimTF}
                        horaDeFimTF={this.state.horaDeFimTF}
                        observacao={this.state.observacao}
                        editar={this.state.editar}
                        errors={parametrosPreProjetoValidationError}
                        onChange={this.handleChange}
                        onSave={this.criarNovoParam}
                        onEdit={this.editarParam}
                    />
                </ParamsPreProjetoCardWithState>
            </>
        )
    }
}